import { render, staticRenderFns } from "./GestionPage.vue?vue&type=template&id=4b874387"
import script from "./GestionPage.js?vue&type=script&lang=js&external"
export * from "./GestionPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports